import { Metamodel } from 'shell-models-lib';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { SqlBaseSettings } from './sql-base-settings';
import { DataFlowSource } from '../dataflow-source';
import { DataFlowExpression } from '../dataflowexpression';
import { IntegerDataFlowType } from '../dataflow-datatype';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureSqlDW.dataflowSettings,
    validator: SynapseAnalyticsSettings.validateSettings
})
export class SynapseAnalyticsSettings extends SqlBaseSettings {
    @Metamodel.attribute({
    })
    public staged: boolean;

    @Metamodel.attribute({
        constraint: {
            validator: DataFlowSource.validateBatchSize
        }
    })
    public batchSize: DataFlowExpression;

    public useCopyCommandForStaging: boolean;

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.SynapseAnalytics;
    }

    public getIconClass(): string {
        return 'i-100x100-AzureSynapse';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.staged = true;
        this.useCopyCommandForStaging = true;
        this.store = DatasetFormatType.SynapseAnalytics;
        this.batchSize = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
    }
}
